import React from 'react';
import { SANDBOX_TYPES } from './sandboxConfig';

function SandboxTypeTabs({ activeType, onChange, onRegenerateClick }) {
  const active = SANDBOX_TYPES.find((t) => t.key === activeType);
  const activeLabel = active?.label || activeType.toUpperCase();

  return (
    <div className="flex items-center border-b border-surface-200">
      <div className="flex gap-6">
        {SANDBOX_TYPES.map((type) => (
          <button
            key={type.key}
            type="button"
            onClick={() => onChange(type.key)}
            className={`pb-2 text-sm font-medium transition-colors ${
              activeType === type.key
                ? 'text-surface-900 border-b-2 border-accent-500'
                : 'text-surface-500 hover:text-surface-700'
            }`}
          >
            {type.label}
          </button>
        ))}
      </div>
      <button
        type="button"
        className="btn btn-ghost text-xs ml-auto mb-1"
        onClick={onRegenerateClick}
      >
        ↻ Regenerate {activeLabel} data
      </button>
    </div>
  );
}

export default SandboxTypeTabs;
